import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { sortData } from "../helpers" 
import { filterMapping, sizesOrder, colorMap } from "../config"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-p-4 facet-group__header"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <h4 class="ns-color-black ns-font-4">{facet.name}</h4>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <Icon name="arrow" className="ns-absolute" />
            </span>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4" facet-name={facet.name} id={`${facet.id}-sub-menu`}>
                <ul class="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                {/* {(facet.name.toLowerCase().trim() === 'size' ? sortData(facet.data, sizesOrder, (item) => item.value) : facet.data)?.map(value => (
                        <li
                            key={value.value}
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-border-radius-3">
                                ({value.count})
                            </span>
                        </li>
                    ))} */}
                     {(() => {
                        
                        const fName = facet.name?.trim().toLowerCase();
                        const isSize = fName === 'size';
                        const isColour = fName === 'colour' || fName === 'color';
                        const list = isSize ? sortData(facet.data, sizesOrder, (item) => item.value) : facet.data;

                        return list?.map((value, index) => {
                            const safeValue = String(value.value).toLowerCase().replace(/\s+/g, '-');
                            const inputId = `nosto-${index}-${safeValue}`;

                            if (isColour) {
                            const colorValue = colorMap[safeValue] || value.value; // fallback if not in map
                            // Check if the value is a URL string for an image
                            const isImage = typeof colorValue === 'string' && colorValue.includes('.png');

                            // Conditionally create the style object for the color swatch
                            const swatchStyle = isImage
                                ? {
                                    // Style for patterns like gingham or floral
                                    backgroundImage: `url(https://${colorValue})`,
                                    backgroundSize: '100% 100%', 
                                }
                                : {
                                    // Style for solid colors
                                    backgroundColor: colorValue,
                                };

                            return (
                                <li
                                key={value.value}
                                class="list-menu__item facets__item"
                                data-nosto-element="facet-setting"
                                role="menuitem"
                                >
                                <label htmlFor={inputId} class="custom-checkbox__label ns-d-flex ns-align-items-center ns-gap-1">
                                    <input
                                    id={inputId}
                                    class="custom-checkbox__input"
                                    type="checkbox"
                                    name={inputId}
                                    checked={!!value.selected}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        toggleProductFilter(facet.field, value.value, !value.selected);
                                    }}
                                    />
                                    <span
                                    class="custom-checkbox__checkbox"
                                    style={swatchStyle}
                                    />
                                    <span>{value.value}</span>
                                </label>
                                </li>
                            );
                            }

                            if (isSize){
                                
                            }

                            // Default LI
                            return (
                            <li
                                key={value.value}
                                class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                                data-nosto-element="facet-setting"
                                role="menuitem"
                            >
                                <Checkbox
                                value={facet.name == "Size" ? value.value : value.value.replaceAll("-"," ")}
                                selected={value.selected}
                                onChange={(e) => {
                                    e.preventDefault();
                                    toggleProductFilter(facet.field, value.value, !value.selected);
                                }}
                                />
                                <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-border-radius-3">
                                ({value.count})
                                </span>
                            </li>
                            );
                        });
                        })()}


                </ul>
            </div>
        </li>
    )
}
